import { render, staticRenderFns } from "./webhook-modal.vue?vue&type=template&id=5b35add3&"
import script from "./webhook-modal.vue?vue&type=script&lang=js&"
export * from "./webhook-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports